export default "__VITE_ASSET__BbqthYUn__"